import { COLOR } from "@lookiero/aurora";
import { ServiceStatus } from "../../../../../../domain/entities/order/Order";
import { ItemStatus } from "../../../../../../domain/entities/product/Product";

const MAX_COLUMNS = 5;

const IMAGE_WIDTH = 56;
const IMAGE_HEIGHT = 70;

const INVALID_ITEM_STATUS = [
  ItemStatus.UNAVAILABLE,
  ItemStatus.DISCARDED,
  ItemStatus.RETURN_DONE,
  ItemStatus.TO_RETURN,
];

type CompletedOrderStatus =
  | ServiceStatus.CANCELLED
  | ServiceStatus.CLOSED
  | ServiceStatus.DELIVERY_NOTIFIED
  | ServiceStatus.DISCARDED
  | ServiceStatus.SELECTION_DONE
  | ServiceStatus.SENT
  | ServiceStatus.WAREHOUSE_ERROR;

const STATUS_COLOR: Record<CompletedOrderStatus, COLOR> = {
  CANCELLED: COLOR.BG_WARNING_LIGHT,
  CLOSED: COLOR.BG_PROMOTION,
  DELIVERY_NOTIFIED: COLOR.BG_PROMOTION,
  DISCARDED: COLOR.BG_WARNING_LIGHT,
  SELECTION_DONE: COLOR.BG_PRIMARY_MEDIUM_LIGHT,
  SENT: COLOR.BG_SURFACE,
  WAREHOUSE_ERROR: COLOR.BG_PRIMARY_MEDIUM_LIGHT,
};

export type { CompletedOrderStatus };
export { IMAGE_HEIGHT, IMAGE_WIDTH, INVALID_ITEM_STATUS, MAX_COLUMNS, STATUS_COLOR };
